import {MultiLanguageString} from "./multi-language-string";
import {IKnowledgeItem} from "./i-knowledge-item";

export class KnowledgeItem {
    public constructor(public description: MultiLanguageString) {
    }

    public static fromInterface(iKnowledgeItem: IKnowledgeItem): KnowledgeItem {
        return new KnowledgeItem(MultiLanguageString.fromInterface(iKnowledgeItem.description));
    }
}
